import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import ModuleVersionInputsCodePreview from "../../components/CodePreview";
import { formatDefaultValue } from "../../utils";
import { ModuleVersionOptionalInputRow } from "../types";

const ModuleVersionInputsTableDefaultCell = ({
  item: input,
  ...cellProps
}: TableSimpleCellProps<ModuleVersionOptionalInputRow>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {input.default && (
        <ModuleVersionInputsCodePreview
          code={formatDefaultValue(input.default)}
          title={`${input.id} default`}
        />
      )}
      {!input.default && <TableCellEmpty />}
    </TableSimpleCell>
  );
};

export default ModuleVersionInputsTableDefaultCell;
